import {
  AutocompleteInput,
  minValue,
  NumberInput,
  ReferenceInput,
  required,
  useSimpleFormIteratorItem,
} from "react-admin";
import { useWatch } from "react-hook-form";
import { Grid } from "@mui/material";
import { studentRequests } from "api/studentApi";

const OptionsIteratorItem = () => {
  const { index } = useSimpleFormIteratorItem();
  const specialityId = useWatch({ name: "specialityId" });
  const options = useWatch({ name: "options" });

  const excludeCurriculumIds = options
    ?.filter((_, i) => i !== index)
    ?.map(row => row?.curriculumId)
    ?.filter(Boolean);

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceInput
          source="curriculumId"
          reference={studentRequests.getCurriculumsSelect()}
          filter={{
            specialityId,
            ...(excludeCurriculumIds?.length ? { ExcludeIds: excludeCurriculumIds } : {}),
          }}
        >
          <AutocompleteInput
            label="Учебен план"
            optionText="name"
            fullWidth
            disabled={!specialityId}
            validate={required()}
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <NumberInput
          source="placesCount"
          label="Брой места"
          validate={[required(), minValue(1)]}
          onWheel={e => e.target.blur()}
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

export default OptionsIteratorItem;
